import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import PlatformsShowcase from "./PlatformsShowcase";

export default function Hero() {
  return (
    <section id="top" className="relative pt-12 md:pt-16 pb-12 md:pb-20 px-2 overflow-hidden">
      <div className="relative max-w-[76rem] mx-auto">
        {/* Top Broadcast Badge */}
        <div className="mb-4 md:mb-6 flex justify-center lg:justify-start">
          <div className="flex items-center gap-4 px-3 py-2">
            <img
              src="https://customer-assets.emergentagent.com/job_elite-portal-11/artifacts/ya7vam3j_Motivation%20%26%20Success%20Network%20White%20and%20Gold%202D%281%29.png"
              alt="Motivation & Success Network"
              className="w-16 h-9 md:w-20 md:h-11 object-contain shrink-0"
            />
            <div className="leading-none text-left uppercase">
              <div className="text-[11px] md:text-[13px] tracking-[0.34em] text-white/40 font-semibold">
                A Motivation &amp; Success
              </div>
              <div className="text-[12px] md:text-[14px] tracking-[0.34em] font-semibold mt-1">
                <span className="text-[#f5c451]">Network</span>{" "}
                <span className="text-white/45">Broadcast</span>
              </div>
            </div>
          </div>
        </div>

        {/* Hero Main Grid: Headline on Left, Magazine Cover on Right */}
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          {/* Left Column: Headline, Subheadline & CTAs */}
          <div className="lg:col-span-7 xl:col-span-8 text-center lg:text-left">
            <h1 className="fade-up font-display leading-[0.92] tracking-tight">
              <span className="block text-white text-[38px] sm:text-5xl md:text-6xl lg:text-[70px] xl:text-[82px]">
                BE FEATURED ON
              </span>
              <span className="block text-blue-bold text-[38px] sm:text-5xl md:text-6xl lg:text-[70px] xl:text-[82px] mt-2">
                PRODUCERS
              </span>
              <span className="block text-blue-bold text-[38px] sm:text-5xl md:text-6xl lg:text-[70px] xl:text-[82px]">
                TODAY
              </span>
            </h1>

            <p className="fade-up max-w-2xl mx-auto lg:mx-0 mt-6 sm:mt-8 text-base md:text-xl leading-relaxed text-white/75">
              Share your annuity expertise with over{" "}
              <span className="text-[#f5c451] font-semibold">6.8 billion users</span>{" "}
              across the world&apos;s top podcast and television platforms.{" "}
              <span className="text-[#14b8a6] font-semibold italic">
                completely free of charge.
              </span>
            </p>

            <div className="fade-up mt-8 sm:mt-10 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <a href="#apply">
                <Button className="btn-gold rounded-md h-14 px-8 text-sm md:text-base font-display tracking-[0.10em] group shadow-lg">
                  APPLY NOW &nbsp; IT&apos;S FREE
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
                </Button>
              </a>
              {/* <Link to="/magazine">
                <Button
                  variant="outline"
                  className="rounded-md h-14 px-6 text-sm md:text-base font-display tracking-[0.10em] border-white/20 hover:border-[#f5c451] hover:bg-[#f5c451]/10 text-white hover:text-[#f5c451] transition-all group"
                >
                  <BookOpen className="mr-2 w-4 h-4 text-[#f5c451]" />
                  READ FREE MAGAZINE
                </Button>
              </Link> */}
            </div>
          </div>

          {/* Right Column: Magazine Cover Beside Headline */}
          <div className="lg:col-span-5 xl:col-span-4 flex justify-center lg:justify-end">
            <Link
              to="/magazine"
              className="group relative block text-center cursor-pointer transition-transform duration-300"
              title="Click to Read Producers Today Free Magazine"
            >
              {/* Glowing ambient light behind cover */}
              <div className="absolute -inset-3 rounded-2xl bg-gradient-to-tr from-[#f5c451]/30 via-orange-500/25 to-blue-500/20 blur-2xl opacity-60 group-hover:opacity-100 transition-opacity duration-500" />

              {/* 3D Magazine Cover Card */}
              <div className="relative rounded-xl overflow-hidden border-2 border-white/20 group-hover:border-[#f5c451] transition-all duration-300 shadow-[0_20px_60px_rgba(0,0,0,0.9)] bg-black w-[240px] sm:w-[280px] md:w-[310px] aspect-[3/4] group-hover:scale-[1.03] group-hover:-rotate-1">
                <img
                  src="/magazine-cover.jpg"
                  alt="Producers Today Magazine Cover - Tom Hegna Issue"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent pointer-events-none" />

                {/* Top Badge
                <div className="absolute top-3 left-3 bg-[#f5c451] text-black font-black text-[10px] tracking-widest uppercase px-2.5 py-1 rounded shadow-md flex items-center gap-1">
                  <Sparkles className="w-3 h-3" /> FREE ISSUE
                </div> */}

                {/* Hover overlay hint */}
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-4">
                  <div className="bg-[#f5c451] text-black font-display font-bold text-xs uppercase tracking-wider px-4 py-2 rounded-md shadow-xl flex items-center gap-1.5 transform translate-y-2 group-hover:translate-y-0 transition-transform">
                    <span>READ FREE ISSUE</span>
                    <ArrowRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </div>

              {/* Caption under cover */}
              <div className="mt-3.5 text-center">
              
                <div className="text-[11px] text-white/45 tracking-wider uppercase mt-0.5">
                  Click To Claim Your Digital Copy
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Bottom subtitle */}
        <div className="mt-14 md:mt-20 text-center">
          <div className="text-[10px] md:text-xs tracking-[0.32em] uppercase text-white/45 font-semibold">
            Heard and Seen Across the World&apos;s Biggest Platforms
          </div>
        </div>
      </div>

      {/* Platforms showcase grid */}
      <PlatformsShowcase />
    </section>
  );
}
